import {
  SinglePageHeaderWrapper,
  SinglePageSubHeaderWrapper,
} from 'packages/signup/components/layouts/singlePageComponents/SinglePageHeading';
import SinglePageFooterWrapper from 'packages/signup/components/layouts/singlePageComponents/SinglePageFooter';

const SinglePageWrapper = ({ contentType }: { contentType: string }) => {
  return (
    <>
      <SinglePageHeaderWrapper contentType={contentType} />
      <SinglePageSubHeaderWrapper contentType={contentType} />
      <SinglePageFooterWrapper contentType={contentType} />
    </>
  );
};

export default SinglePageWrapper;
